<template>
  <div class="ce-contactForm">
    <div
      class="ce-contactForm-toggle"
      @click.prevent="show">
      <slot />
    </div>

    <modal
      v-if="visible"
      :headline="headline"
      :description="description"
      class="ce-contactFormModal"
      @close="close">
      <contact-form
        v-if="!finished"
        :contact-type="contactType"
        :additional-data="additionalData"
        @finished="finished = true"
        in-modal />
      <div
        v-if="finished"
        class="ce-modalContent">
        <p>{{ $t('contactForm.finishedMessage') }}</p>

        <div class="mt4">
          <button
            class="ce-btn ce-btn-light ce-btn--fullWidth"
            @click.prevent="close">
            {{ $t('contactForm.finishedCloseCta') }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ContactForm from 'components/forms/ContactForm.vue';

export default {
  components: { ContactForm },
  props: {
    /**
     * One of the available contact types:
     * - bce
     * - psr
     * - account_manager
     * - customer_service
     * - data_protection_officer
     */
    contactType: {
      type: String,
      required: true
    },
    headline: {
      type: String,
      required: false,
      default: null
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    additionalData: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      finished: false
    };
  },
  methods: {
    reset() {
      this.finished = false;
    },
    show() {
      this.visible = true;
    },
    close() {
      this.reset();
      this.visible = false;
    }
  }
};
</script>

<style lang="less">
  .ce-contactForm {
    .ce-contactForm-toggle {
      cursor: pointer;
    }
  }
</style>
